import React, { ComponentType, ReactElement, ReactNode } from "react";
import styled from "styled-components";
import RouterLink from "redux-first-router-link";
import { FieldValue as FieldValueUI } from "@evergis/ui";

import { commonWidth as containerWidth } from "./DialogComponents/styled";

type FieldValueComponent = ComponentType<
  Omit<PropsOf<typeof FieldValueUI>, "value" | "field"> & { value: ReactNode; field: ReactNode }
>;

export const FieldValue = styled<FieldValueComponent>(FieldValueUI)`
  min-width: 4.376rem;
  flex-wrap: nowrap;
  flex-shrink: 0;
`;

export const DataField = styled.span<{ column?: boolean }>`
  display: flex;
  flex-direction: ${({ column }) => (column ? "column" : "row")};

  > ${FieldValue} {
    :not(:last-of-type) {
      margin: ${({ column }) => (column ? "0 0 1rem 0" : "0 2rem 0 0")};
    }
  }
`;

const HeaderText = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: ${containerWidth - 13.5}rem;
  white-space: nowrap;
`;

const HeaderTextContainer = styled.span`
  display: flex;
`;

export const Container = styled.span`
  display: flex;
`;

export const TextInfoContainer = styled.span`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const DescriptionBlock = styled.span`
  color: ${({ theme: { palette } }) => palette.textSecondary};
`;

export const ExtraButtonsContainer = styled.span`
  display: flex;
  margin-right: 1rem;
  flex-grow: 1;
`;

export const DialogContainer = styled.div`
  .buttons-group {
    margin-top: -1rem;
    margin-bottom: 0.5rem;
  }
`;

export const Descr = styled.div`
  margin-bottom: 1.5rem;
  font: ${({ theme: { fonts } }) => fonts.description};
  color: ${({ theme: { palette } }) => palette.textSecondary} !important;
`;

export const ContrastDescr = styled(Descr)`
  margin-bottom: 0;
  color: ${({ theme: { palette } }) => palette.textPrimary};
`;

export const Info = styled(Descr)`
  margin-top: 0.5rem;
  margin-bottom: 2rem;
`;

export const InfoWithBackground = styled(Descr)`
  margin-bottom: 1.5rem;
  padding: 0.625rem;
  background-color: ${({ theme: { palette } }) => palette.elementDark};
  border: 1px ${({ theme: { palette } }) => palette.elementDeep} solid;
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.smallest};
  font: ${({ theme: { fonts } }) => fonts.description};
  color: ${({ theme: { palette } }) => palette.textSecondary};
`;

export const InfoLink = styled(RouterLink)`
  text-decoration: none !important;
  font: ${({ theme: { fonts } }) => fonts.description};
  color: ${({ theme: { palette } }) => palette.primary} !important;
`;

export const styledHeaderText = (headerText = "", label = ""): ReactElement => {
  return (
    <HeaderTextContainer>
      <HeaderText title={headerText}>{headerText}</HeaderText>
      {label && <span>&nbsp;— {label}</span>}
    </HeaderTextContainer>
  );
};
